'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (_ref, _ref2) {
  var background = _ref.background,
      foreground = _ref.foreground,
      columns = _ref.columns,
      styles = _ref.styles;
  var colors = _ref2.colors,
      mediaQuery = _ref2.mediaQuery,
      scale = _ref2.scale,
      rhythm = _ref2.rhythm,
      justifyContent = _ref2.justifyContent,
      treatments = _ref2.treatments;

  var createColumns = function createColumns() {
    return Object.keys(columns).reduce(function (styles, breakpoint) {
      return _extends({}, styles, _defineProperty({}, mediaQuery(breakpoint), {
        columnCount: columns[breakpoint]
      }));
    }, {});
  };

  var defaultStyles = {
    root: _extends({
      backgroundColor: background && colors[background],
      color: foreground && colors[foreground]
    }, treatments.leaderboard),

    leaders: _extends({
      counterReset: 'board'
    }, createColumns(), treatments.leaderboardLeaders),

    state: _extends({
      display: 'flex',
      alignItems: 'flex-start'
    }, justifyContent('center'), {
      padding: rhythm(2),
      fontSize: scale(-1)
    }, treatments.leaderboardState, {

      '& > *': {
        margin: rhythm([0, 0.25])
      }
    })
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/leaderboard/styles.js
// module id = 904
// module chunks = 0